// store/middleware/cartCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const cartCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith?.("cart/")) {
      const cartItems = store.getState().cart.items;

      try {
        const version = getCacheVersion();
        const CACHE_KEY = `cart_v${version}`;
        saveToStorage(CACHE_KEY, cartItems);
      } catch (error) {
        // Игнорируем ошибки кэша
      }
    }

    return result;
  };